const mapSnapshot = ({
	id,
	parentId,
	name,
	linkStatusId,
	scopeId,
	snapshotId,
	sentDate,
	gaInstructionStatusId,
	primaryInstructionSetId
}) => ({
	componentId: id,
	parentComponentId: parentId,
	componentName: name,
	linkStatusId,
	scopeId,
	snapshotId,
	sentDate,
	gaInstructionStatusId,
	setId: primaryInstructionSetId
});

export default (snapshots) => snapshots?.map(mapSnapshot);
